import { isEmpty } from "@/utils/var.check";
import { RESOURCE_SEARCH_TYPE } from "@modules/resource-search/resource-search-helper.ts";
import { useContentSubpageInstance } from "@plugins/content-subpage/composables/content-subpage-instance.ts";
import WhitelistWebsiteDetailsContentSubpage from "@modules/whitelist-website/components/view/WhitelistWebsiteDetailsContentSubpage.vue";
import { ResourceCardProps } from "@/common/card-types.ts";
import { WebsiteResultItem } from "@modules/resource-search/resource-search-types.ts";
import i18n from "@/plugins/i18n";
import { useI18n } from "vue-i18n";

export const useWebsiteCard = () => {
  const { t } = useI18n();
  const contentSubpageInstance = useContentSubpageInstance();

  const populateWebsiteCardProps = (
    resourceData: WebsiteResultItem,
    showViewDetails: boolean,
  ): ResourceCardProps => {
    return {
      searchType: RESOURCE_SEARCH_TYPE.WEBSITE,
      uuid: resourceData.uuid,
      title: resourceData.name,
      metadata: i18n.t("whitelisted_website_card_metadata_label"),
      thumbnail: {
        type: resourceData?.iconUrl ? "image" : "icon",
        value: resourceData?.iconUrl ?? "Website32",
      },
      ariaLabelConfig: {
        cardComponent: t("search_resource_card_open_in_new_tab_aria_label"),
        viewDetails: t("search_view_details_aria_label", {
          title: resourceData.name,
        }),
      },
      showViewDetails,
    };
  };

  const populateWebsiteCardListeners = (
    resourceData: WebsiteResultItem,
  ): { click: () => void; viewDetails: () => void } => {
    return {
      click: () => handleClick(resourceData),
      viewDetails: () => handleViewDetails(resourceData),
    };
  };

  const handleClick = (resourceData: WebsiteResultItem): void => {
    if (!isEmpty(resourceData.homeUrl)) {
      window.open(resourceData.homeUrl, "_blank", "noreferrer,noopener");
    }
  };

  const handleViewDetails = (resourceData: WebsiteResultItem): void => {
    contentSubpageInstance.show(WhitelistWebsiteDetailsContentSubpage, {
      baseTitle: [resourceData.name],
      websiteUuid: resourceData.uuid,
    });
  };

  return {
    populateWebsiteCardProps,
    populateWebsiteCardListeners,
    handleViewDetails,
  };
};
